export const PAYMENT_STEP = 'payment';
export const DELIVERY_STEP = 'delivery';
export const DIRECT_ACCESS_FORBIDDEN_STEPS = ['credit', 'congratulations'];
export const NEXT_STEPS_STEP = 'next-steps';
export const CONGRATULATIONS_STEP = 'congratulations';
export const DEAL_CHECK = 'deal-check';
